import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

/**
 * Legacy route — redirects to /auth/google-callback which handles both
 * login and onboarding flows with a single Google redirect URI.
 */
export const Route = createFileRoute("/_auth/login/google-callback")({
	validateSearch: (search) =>
		z
			.object({
				code: z.string().min(1).optional(),
				state: z.string().min(1).optional(),
				error: z.string().optional(),
			})
			.parse(search),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/auth/google-callback",
			search,
		});
	},
});
